import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/style.css'
import axios from "axios";
import router from './router'
import dayjs from 'dayjs'
import VCurrencyField from 'v-currency-field'
import DatetimePicker from 'vuetify-datetime-picker'
import VueLazyload from 'vue-lazyload'
import { VueSpinners } from '@saeris/vue-spinners'
import EncryptValue from '@/plugins/encrypt'
import Currency from '@/plugins/currency'
import DecimalPlaces from '@/plugins/decimalPlaces'
import isMobile from '@/plugins/isMobile'
import msal from 'vue-msal'
import VueCookies from 'vue-cookies'
import './registerServiceWorker'
import '@/assets/scss/main.scss'

import MCProgressBar from './components/ui/MCProgressBar.vue';



Vue.use(VueCookies, { expires: '7d' })


Vue.use(msal, {
  auth: {
    clientId: process.env.VUE_APP_MICROSOFT_CLIENT,
  },
});

Vue.config.productionTip = false

Vue.component('mc-progress-bar', MCProgressBar);
Vue.component('ValidationProvider', ValidationProvider);

Vue.component('ValidationObserver', ValidationObserver);

Vue.use(VueLazyload)
Vue.use(VueSpinners)

Vue.use(DatetimePicker);

axios.interceptors.request.use(
  function (config) {
    config.withCredentials = true;
    config.headers['Content-Type'] = "application/json";
    config.headers['Accept'] = "application/json";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Vue.prototype.$fatalError = true;


if (process.env.VUE_APP_NODE_ENV === 'production') {
  console.log = () => {}
  console.info = () => {}
  console.debug = () => {}
  console.warn = () => {}
  // mantém errors visíveis
}

const themes = [
  {
    name: "Padrão",
    light: {
      primary: "#e9cfed",
      primaryLight: "#111b2d0",
      secondary: "#29334b",
      accent: "#9DA6BA",
      error: "#f44336",
      warning: "#E7C02C",
      info: "#03a9f4",
      success: "#4caf50",
      anchor: '#222B3F',
    },
  },


];

Vue.prototype.$themes = themes;

Vue.prototype.$encryptValue = EncryptValue
Vue.prototype.$currency = Currency
Vue.prototype.$decimalPlaces = DecimalPlaces
Vue.prototype.$isMobile = isMobile

Vue.mixin({
  methods: {
    setTheme: function (theme) {
      const dark = theme.dark || {};

      const light = theme.light || {};

      Object.keys(dark).forEach(i => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });

      this.$vuetify.groupSelectedColor = this.$vuetify.theme.dark ? theme.dark.primaryLight
        : theme.light.primaryLight;
    },
    formatDate(date) {
      return date == null ? null : dayjs(date).format('DD/MM/YYYY');
    },
  }
});

Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
